<template>
  <div :class="$style.dynamicFilterContainer">
    <div :class="$style.dynamicFilters">
      <div
        v-for="(item, index) in filters"
        :key="index"
        :class="$style.item"
      >
        <SbCollapsableFilter
          :filter="filter"
          :value="item"
          :version="dsComponentDetails.version"
          @update-filter="updateItem(index, $event)"
        >
          <template #remove-filter>
            <SbButton
              v-if="filters.length > 1"
              data-sb-automation="dynamic-filter-remove"
              version="next"
              variation="tertiary"
              :class="$style.btnRemove"
              :icon="'pi pi-times'"
              @click="removeItem(index)"
            />
          </template>
        </SbCollapsableFilter>
      </div>
    </div>
    <div :class="$style.filterActionsContainer">
      <SbButton
        data-sb-automation="dynamic-filter-add"
        version="next"
        variation="minimal"
        :class="$style.btnAdd"
        :icon="'pi pi-plus'"
        :label="filter?.dynamicProps?.addFilterButtonLabel ?? 'Add Filter'"
        @click="addItem"
      />
    </div>
  </div>
</template>

<script>
import SbButton from '@src/components/Button/SbButton.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import SbCollapsableFilter from '@src/components/Filter/components/SbCollapsableFilter.vue';

export default {
  name: 'SbDynamicCollapsableFilter',
  components: {
    SbCollapsableFilter,
    SbButton,
  },
  mixins: [versionedComponentsMixin],
  props: {
    /**
     * the filter definition (name, key, defaults, etc)
     */
    filter: {
      type: Object,
      required: true,
    },
    /**
     * v-model: an array of { value, operator } objects
     */
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update-filter'],
  computed: {
    filters: {
      get() {
        const value = Array.isArray(this.modelValue) ? this.modelValue : (this.modelValue?.value ?? []);

        return value.length > 0
          ? value.map((val) => this.create(val))
          : [this.create()];
      },
      set(value) {
        const update = {
          key: this.filter.key,
          value: {
            operator: this.modelValue.operator,
            value,
            ...(value?.matchType && { matchType: value?.matchType }),
          },
        };
        this.$emit('update-filter', update);
      },
    },
  },
  methods: {
    create(filterVal = {}) {
      return {
        value: filterVal?.value ?? this.filter.default,
        operator: filterVal?.operator ?? this.filter.defaultOperator,
        ...(
          (filterVal?.matchType || this.filter.defaultMatchType)
          && { matchType: filterVal?.matchType ?? this.filter.defaultMatchType }
        ),
      };
    },
    addItem() {
      this.filters = [...this.filters, this.create()];
    },
    removeItem(idx) {
      const copy = [...this.filters];
      copy.splice(idx, 1);
      this.filters = copy;
    },
    updateItem(idx, { key, value }) {
      const copy = [...this.filters];
      copy[idx] = value;
      this.filters = copy;
    },
  },
};
</script>

<style lang='scss' module>
@use '@src/components/Filter/next/styles/SbDynamicCollapsableFilter.module.scss';
</style>
